/// <reference path="../../../Modules/Attr/Dialog/NoboxEntityDialog.ts" />
namespace Nobox.Administration {

    @Serenity.Decorators.panel()
    export class SettingTenantDialog extends NoboxEntityDialog<TenantRow, any> {
        protected getFormKey() { return SettingTenantForm.formKey; }
        protected getIdProperty() { return TenantRow.idProperty; }
        protected getLocalTextPrefix() { return TenantRow.localTextPrefix; }
        protected getNameProperty() { return TenantRow.nameProperty; }
        protected getService() { return TenantService.baseUrl; }
        protected getDeletePermission() { return TenantRow.deletePermission; }
        protected getInsertPermission() { return TenantRow.insertPermission; }
        protected getUpdatePermission() { return TenantRow.updatePermission; }

        protected form = new SettingTenantForm(this.idPrefix);
        protected tnNM = "";
        protected updateTitle() {
            this.dialogTitle = "Tenant Profile" + " (" + this.get_entity().Nm + ")";
        }

        loadResponse(data) {
            super.loadResponse(data);
            this.tnNM = this.getSaveEntity().Nm;
        }
        protected save(callback1) {
            var name = this.form.Nm.value;
            var channel = this.form.ChannelId.value;
            var accounts = this.form.AccountIds.value;
            var accountemail = this.form.AccountEmail.value;
            var pipeline = this.form.PipelineId.value;
            var stage = this.form.StageId.value;
            var callback = (response) => {
                if (this.tnNM != this.getSaveEntity().Nm) {
                    window.location.reload();
                } else {
                    this.loadById(this.get_entityId());
                    this.showSaveSuccessMessage(response);
                }
            }
            if (this.validateForm()) {
                var cokie = document.cookie;
                cokie = cokie.replace("TnNm= " + encodeURI(name) + ";", "");
                cokie = cokie.replace("Channel= " + encodeURI(channel) + ";", "");
                cokie = cokie.replace("Accounts= " + encodeURI(accounts) + ";", "");
                cokie = cokie.replace("AccountEmail= " + encodeURI(accountemail) + ";", "");
                cokie = cokie.replace("Pipeline= " + encodeURI(pipeline) + ";", "");
                cokie = cokie.replace("Stage= " + encodeURI(stage) + ";", "");
                document.cookie = "TnNm=" + encodeURI(name) + "; path=/";
                document.cookie = "Channel=" + encodeURI(channel) + "; path=/";
                document.cookie = "Accounts=" + encodeURI(accounts) + "; path=/";
                document.cookie = "AccountEmail=" + encodeURI(accountemail) + "; path=/";
                document.cookie = "Pipeline=" + encodeURI(pipeline) + "; path=/";
                document.cookie = "Stage=" + encodeURI(stage) + "; path=/";
                if (this.isNew()) {
                } else {
                    super.save(callback);
                }
            }
        }

        protected getToolbarButtons() {
            var buttons = super.getToolbarButtons();
            buttons.splice(2, 1);
            buttons.push({
                icon: "fa-copy text-blue",
                separator: true,
                title: "Copy Invitation",
                hint: "Copy Link Invitation",
                onClick: () => {
                    var baseUrl = window.location.origin + "/";
                    var path = "Invite/Users/" + this.get_entity().InvCdGen;
                    var url = baseUrl + path;
                    var link = document.createElement('textarea');
                    link.value = `${Q.Authorization.userDefinition.DisplayName} is inviting you to join their tenant in NoBox.Ai. \nTenant: ${this.get_entity().Nm} \n\nJoin ${this.get_entity().Nm} \n${url}`;
                    link.select();
                    link.setSelectionRange(0, 99999);
                    navigator.clipboard.writeText(link.value);
                    Q.notifySuccess("Link invitation copied to clipboard");
                }
            });
            buttons.push({
                icon: "fa-download text-blue",
                separator: true,
                title: "Download Data",
                hint: "Download Data Tenant include database and files",
                onClick: () => {
                    Q.confirm("Do you want to download your files and database?", () => {
                        var link = document.createElement('a');
                        link.href = Q.resolveUrl(`~/Services/Administration/Tenant/DownloadData`);
                        link.click()
                    });
                }
            });
            buttons.push({
                title: "Unsubscribe",
                separator: true,
                icon: "fa-times text-danger",
                onClick: () => {
                    Q.confirm("Are you sure you want to Unsubscribe your tenant?", () => {
                        Q.serviceCall({
                            blockUI: true,
                            url: `/Services/${TenantService.baseUrl}/UnSubscribe`,
                            onSuccess: () => {
                                Q.notifySuccess("Successfully Unsubscribe your tenant");
                                setTimeout(() => {
                                    window.location = "/Account/Signout"
                                }, 500)
                            }
                        })
                    }, {
                        //title: "Unsubscribe your account"
                    });
                }
            })
            return buttons;
        }

        protected CheckAutoResolve(isResolve) {
            if (isResolve == 1 || isResolve == true) {
                Serenity.EditorUtils.setReadOnly(this.form.RHours, false);
                Serenity.EditorUtils.setReadOnly(this.form.RMinutes, false);
            } else {
                Serenity.EditorUtils.setReadOnly(this.form.RHours, true);
                Serenity.EditorUtils.setReadOnly(this.form.RMinutes, true);
            }
        }
        protected CheckAutoArchive(isArchive) {
            if (isArchive == 1 || isArchive == true) {
                Serenity.EditorUtils.setReadOnly(this.form.AHours, false);
                Serenity.EditorUtils.setReadOnly(this.form.AMinutes, false);
            } else {
                Serenity.EditorUtils.setReadOnly(this.form.AHours, true);
                Serenity.EditorUtils.setReadOnly(this.form.AMinutes, true);
            }
        }

        protected CheckSunday(val) {
            var value = val == 1 || val == true ? true : false;
            this.form.fSunday.getGridField().toggle(value);
            this.form.lSunday.getGridField().toggle(value);
            this.form.nSunday.getGridField().toggle(!value);
        }

        protected CheckMonday(val) {
            var value = val == 1 || val == true ? true : false;
            this.form.fMonday.getGridField().toggle(value);
            this.form.lMonday.getGridField().toggle(value);
            this.form.nMonday.getGridField().toggle(!value);
        }

        protected CheckTuesday(val) {
            var value = val == 1 || val == true ? true : false;
            this.form.fTuesday.getGridField().toggle(value);
            this.form.lTuesday.getGridField().toggle(value);
            this.form.nTuesday.getGridField().toggle(!value);
        }

        protected CheckWednesday(val) {
            var value = val == 1 || val == true ? true : false;
            this.form.fWednesday.getGridField().toggle(value);
            this.form.lWednesday.getGridField().toggle(value);
            this.form.nWednesday.getGridField().toggle(!value);
        }

        protected CheckThursday(val) {
            var value = val == 1 || val == true ? true : false;
            this.form.fThursday.getGridField().toggle(value);
            this.form.lThursday.getGridField().toggle(value);
            this.form.nThursday.getGridField().toggle(!value);
        }

        protected CheckFriday(val) {
            var value = val == 1 || val == true ? true : false;
            this.form.fFriday.getGridField().toggle(value);
            this.form.lFriday.getGridField().toggle(value);
            this.form.nFriday.getGridField().toggle(!value);
        }

        protected CheckSaturday(val) {
            var value = val == 1 || val == true ? true : false;
            this.form.fSaturday.getGridField().toggle(value);
            this.form.lSaturday.getGridField().toggle(value);
            this.form.nSaturday.getGridField().toggle(!value);
        }

        protected CheckDuring(val) {
            var value = val == 1 || val == true ? true : false;
            Serenity.EditorUtils.setReadOnly(this.form.DuringMsg, !value);
        }
        protected CheckOutside(val) {
            var value = val == 1 || val == true ? true : false;
            Serenity.EditorUtils.setReadOnly(this.form.OutsideMsg, !value);
        }

        protected updateInterface() {
            super.updateInterface();
            var $this = this;
            var item = this.get_entity();
            this.CheckAutoResolve(item.IsAutoResolve);
            this.CheckAutoArchive(item.IsAutoArchive);
            this.form.IsAutoResolve.change(function () {
                $this.CheckAutoResolve($this.form.IsAutoResolve.value);
            })
            this.form.IsAutoArchive.change(function () {
                $this.CheckAutoArchive($this.form.IsAutoArchive.value);
            })
            this.form.TenantMembers.callbackSave = () => {
                $this.loadById($this.get_entityId());
                var res = {} as Serenity.SaveResponse;
                $this.showSaveSuccessMessage(res);
            }
            this.form.TenantMembers.items = this.get_entity().TenantMembers;
            this.form.TenantMembers.maxuser = item.MaxUser;
            this.form.TenantMembers.membership = item.Level == 1 ? "Trial" : item.Level == 2 ? "Basic" : item.Level == 3 ? "Pro" : item.Level == 4 ? "Unlimited" : "Unlimited";
            this.form.TenantMembers.updateButton();
            $(".inplace-action3").remove();
            $('<a class="inplace-button inplace-action3"><b><i class="far fa-recycle text-primary"></i></b></a>')
                .attr("title", "Generate new Invite Code")
                .insertAfter(this.form.InvCdGen.element)
                .click(e => {
                    Q.confirm("Are you sure to generate new invite code?", () => {
                        Q.serviceCall({
                            blockUI: true,
                            url: "/Services/Administration/Tenant/GenerateInvtCode",
                            onSuccess: (res: Serenity.SaveResponse) => {
                                if (res != null) {
                                    this.form.InvCdGen.value = res.EntityId;
                                }
                            },
                            onError: (err: Serenity.ServiceResponse) => {
                                Q.ErrorHandling.showServiceError(err.Error);
                            }
                        })
                    });
                });
            $(".inplace-action4").remove();
            $('<a class="inplace-button inplace-action4"><b><i class="far fa-copy text-primary"></i></b></a>')
                .attr("title", "Copy Tenant Id to clipboard")
                .insertAfter(this.form.Id.element)
                .click(e => {
                    var link = document.createElement('textarea');
                    link.value = `${this.get_entityId()}`;
                    link.select();
                    link.setSelectionRange(0, 99999);
                    navigator.clipboard.writeText(link.value);
                    Q.notifySuccess("Tenant Id copied to clipboard");
                });

            //Office Hours
            $this.CheckSunday(item.Sunday);
            this.form.Sunday.change(function () {
                $this.CheckSunday($this.form.Sunday.value);
            })

            $this.CheckMonday(item.Monday);
            this.form.Monday.change(function () {
                $this.CheckMonday($this.form.Monday.value);
            })

            $this.CheckTuesday(item.Tuesday);
            this.form.Tuesday.change(function () {
                $this.CheckTuesday($this.form.Tuesday.value);
            })

            $this.CheckWednesday(item.Wednesday);
            this.form.Wednesday.change(function () {
                $this.CheckWednesday($this.form.Wednesday.value);
            })

            $this.CheckThursday(item.Thursday);
            this.form.Thursday.change(function () {
                $this.CheckThursday($this.form.Thursday.value);
            })

            $this.CheckFriday(item.Friday);
            this.form.Friday.change(function () {
                $this.CheckFriday($this.form.Friday.value);
            })

            $this.CheckSaturday(item.Saturday);
            this.form.Saturday.change(function () {
                $this.CheckSaturday($this.form.Saturday.value);
            })

            //Auto Responder
            $this.CheckDuring(item.During);
            this.form.During.change(function () {
                $this.CheckDuring($this.form.During.value);
            })

            $this.CheckOutside(item.Outside);
            this.form.Outside.change(function () {
                $this.CheckOutside($this.form.Outside.value);
            })
        }

        dialogClose() {

        }

        dialogOpen() {
            super.dialogOpen();

            this.element.children("div.panel-titlebar").find("button.panel-titlebar-close").remove();
            this.element.children("div.panel-titlebar").css("justify-content", "space-between");
            this.element.children("div.panel-titlebar").append(`<a style="border-radius: 4px;border: 1px solid var(--s-tool-border);margin-left:5px;" class="btn btn-icon btn-sm p-0 ml-1 float-right" target="_blank" href="${$('#GridDiv').attr('help-url')}">
                    <div class="tool-button icon-tool-button" title="Help">
                        <div class="button-outer">
                            <span class="button-inner green">
                                <i class="fa fa-question-circle text-blue"></i>
                            </span>
                        </div>
                    </div>
                </a>`);
            Q.Router.replace("");
        }

        public MemberActive() {
            this.element.find(".nav-tabs.property-tabs").children("li").eq(0).children("a").removeClass("active");
            this.element.find(".nav-tabs.property-tabs").children("li").eq(1).children("a").addClass("active");
            this.element.find(".tab-content.property-panes").children(".tab-pane").eq(0).removeClass("show");
            this.element.find(".tab-content.property-panes").children(".tab-pane").eq(0).removeClass("active");
            this.element.find(".tab-content.property-panes").children(".tab-pane").eq(1).addClass("show");
            this.element.find(".tab-content.property-panes").children(".tab-pane").eq(1).addClass("active");
        }
        public IntegrationActive() {
            this.element.find(".nav-tabs.property-tabs").children("li").eq(0).children("a").removeClass("active");
            this.element.find(".nav-tabs.property-tabs").children("li").eq(2).children("a").addClass("active");
            this.element.find(".tab-content.property-panes").children(".tab-pane").eq(0).removeClass("show");
            this.element.find(".tab-content.property-panes").children(".tab-pane").eq(0).removeClass("active");
            this.element.find(".tab-content.property-panes").children(".tab-pane").eq(2).addClass("show");
            this.element.find(".tab-content.property-panes").children(".tab-pane").eq(2).addClass("active");
        }

        protected onSaveSuccess(response) {
            super.onSaveSuccess(response);
        }
    }
}